exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Structure */\n.example-container {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    min-width: 300px;\n}\n\n.example-header {\n    min-height: 64px;\n    padding: 8px 24px 0;\n}\n\n.mat-form-field {\n    font-size: 14px;\n    width: 100%;\n}\n\n.mat-table {\n    overflow: auto;\n    max-height: 500px;\n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/oneills-web-qa/src/app/dashboard/dashboard.component.css
// module id = ../../../../../src/app/dashboard/dashboard.component.css
// module chunks = main